<template>
  <div ref="kraken" class="kraken">
    <img class="killer" src="../assets/close.svg" @click="killKraken" alt />
    <div @click="killKraken" class="content">
      <router-link class="logo" to="/">
        <p>Home</p>
      </router-link>
      <router-link class="about" to="/about">
        <p>About Us</p>
      </router-link>
      <router-link class="contact" to="/contact">
        <p>Contact</p>
      </router-link>
      <p @click="killKraken">Close</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Kraken",
  computed: {
    ...mapGetters(["kraken"])
  },
  watch: {
    kraken: function(command) {
      if (command) {
        this.$refs.kraken.classList.add("show");
      } else this.$refs.kraken.classList.remove("show");
    }
  },
  methods: {
    killKraken: function() {
      this.$store.dispatch("kraken", false);
    }
  }
};
</script>

<style scoped lang="scss">
img {
  width: 1.2rem;
  height: 1.2rem;
}

.killer {
  position: absolute;
  top: 1rem;
  right: 1rem;
}
.kraken {
  position: fixed;
  z-index: 8;
  transform: translateY(100%);
  transition: transform 1.5s ease-in-out;
  background: $lightPrimary;
  min-height: 100vh;
  height: calc(100% + 4px);
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-top: solid 1px black;
  border-bottom: solid 1px black;

  .content {
    font-size: calc(16px + 5vh);
  }
}
.show {
  transform: translateY(-1px);
}
</style>
